import { CatalogCard } from "../components/CatalogCard";
import { SortedCatalog } from "../components/SortedCatalog";
import { fortuneDefinitions } from "./fortuneDefinitions";

export function FortuneCatalog({ limit }: { limit?: number }) {
  return (
    <SortedCatalog
      items={fortuneDefinitions}
      label="Sort Fortune Games"
      limit={limit}
      renderItem={(item) => (
        <CatalogCard
          key={item.name}
          title={item.title}
          heading={limit ? "h3" : "h2"}
          description={item.description}
          image={item.image}
          tags={item.tags}
          to={`/fortune/${item.name}`}
          testId={`fortune-card-${item.name}`}
        />
      )}
    />
  );
}
